module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d1e55eef3b2319cef99497283f02004c.png";